import { render, staticRenderFns } from "./color-modal.vue?vue&type=template&id=63a6abf9"
import script from "./color-modal.vue?vue&type=script&lang=js"
export * from "./color-modal.vue?vue&type=script&lang=js"
import style0 from "./color-modal.vue?vue&type=style&index=0&id=63a6abf9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports